import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthGuard from './AuthGuard';
import Header from '../components/header';
import Footer from '../components/Footer';


function Private({role }) {

  return (
    <>
      <AuthGuard role={role}>
        <Header />
        <Outlet />
        <Footer />
      </AuthGuard>
    </>
  );
}

export default Private;
